import { createContext, useContext } from 'react'
import { GoodwillfindsRequirements, onVariantChangeHandler, Requirements } from './components/JoinedForm/types'

interface ProductFormContextValues {
  errors: any
  product: any // product form product, could have a lot of properties and nested listing data, but most are optional for this flow
  initialProduct: any
  goodwillfindsRequirements: GoodwillfindsRequirements
  setGoodwillfindsRequirements: (goodwillfindsRequirements: GoodwillfindsRequirements) => void
  onListingChange: (marketKey, event, callback?) => void
  onProductChange: (changeHash: any, callback?: () => void) => void
  onCarrierChange: (changeHash: any, callback?: () => void) => void
  onVariantChange: onVariantChangeHandler
  ebayRequirements: Requirements
  templateForm: any
  draft: boolean
}

export const defaultEbayRequirements = (): Requirements => {
  return {
    loading: false,
    bestOfferEnabled: false,
    upc: undefined,
    ean: undefined,
    isbn: undefined,
    specifics: [],
    conditions: [],
    features: undefined,
    itemConditionPolicies: []
  }
}

export const ProductFormContext = createContext<ProductFormContextValues>({
  errors: null,
  initialProduct: null,
  product: null,
  goodwillfindsRequirements: { specifics: [] },
  setGoodwillfindsRequirements: _goodwillfindsRequirements => {},
  onListingChange: (_marketKey, _event, _cb) => {},
  onProductChange: (_changeHash, _callback) => {},
  onCarrierChange: (_changeHash, _callback) => {},
  onVariantChange: (_idx, _key, _value) => {},
  ebayRequirements: defaultEbayRequirements(),
  templateForm: null,
  draft: false
})
export const useProductFormContext = () => useContext(ProductFormContext)
